import { clone, ILoopConfig, EModalType, IValidationConfig } from '../../helpers/';
import types from '../types';

interface ILoopConfigState {
	loopConfig: ILoopConfig;
}

export const initialState: ILoopConfigState = {
	loopConfig: {
		componentId: null,
        Properties: null,
		OutputValues: null,
		previousOutputBlocks: {},
		validationEditIndex: null,
		editedValidationItem: null,
		overIndex: null,
		fromIndex: null,
		summaryColumns: []
    }
};

const loopConfigReducer = function(state:ILoopConfigState = initialState, action): ILoopConfigState {

	let stateClone:ILoopConfigState = clone(state);

	switch(action.type) {
		case types.SET_LOOP_CONFIG:
            stateClone = updateLoopConfig(stateClone, action.loopConfig);
			break;
		case types.TOGGLE_DIALOG:
			if(stateClone.loopConfig.componentId && action.openModal === EModalType.None) {
				stateClone = initialState;
			}
			break;
		default:
			break;
	}

	return stateClone;

};

let updateLoopConfig = (state: ILoopConfigState, loopConfig: ILoopConfig) => {

    state.loopConfig = loopConfig;

    return state;
}

export default loopConfigReducer;


// WEBPACK FOOTER //
// ./source/ts/store/reducers/loop-config.ts